import { graphql, useStaticQuery } from 'gatsby'

export const ourCausesImage = graphql`
  fragment ourCausesImage on File {
    childImageSharp {
      fluid(maxWidth: 504, quality: 100) {
        ...GatsbyImageSharpFluid_withWebp_noBase64
      }
    }
  }
`

export const ourCausesQuery = graphql`
  query {
    amazonImage: file(relativePath: { eq: "ourcauses/amazonia.png" }) {
      ...ourCausesImage
    }
    plasticOceanImage: file(
      relativePath: { eq: "ourcauses/oceano_de_plastico.png" }
    ) {
      ...ourCausesImage
    }
    amazonImageMY: file(relativePath: { eq: "ourcauses/en-my/amazonia.png" }) {
      ...ourCausesImage
    }
    plasticOceanImageMY: file(
      relativePath: { eq: "ourcauses/en-my/oceano_de_plastico.png" }
    ) {
      ...ourCausesImage
    }
    amazonImagePE: file(relativePath: { eq: "ourcauses/en-pe/Imagem2-1_LP-Peru.png" }) {
      ...ourCausesImage
    }
    eloImageCOFirst: file(relativePath: { eq: "ourcauses/en-co/Imagem2-1_LP-Colombia.png" }) {
      ...ourCausesImage
    }
    eloImageCOSecond: file(relativePath: { eq: "ourcauses/en-co/Imagem2-2_LP-Colombia.png" }) {
      ...ourCausesImage
    }
    plasticOceanImagePE: file(
      relativePath: { eq: "ourcauses/en-pe/Imagem2-2_LP-Peru.png" }
    ) {
      ...ourCausesImage
    }
    eloImageCLFirst: file(relativePath: { eq: "ourcauses/en-cl/3_LP_Consultoria_de_Belleza_web_1_produto.jpg" }) {
      ...ourCausesImage
    }
    eloImageCLSecond: file(
      relativePath: { eq: "ourcauses/en-cl/3_LP_Consultoria_de_Belleza.jpg" }
    ) {
      ...ourCausesImage
    }
  }
`
/**
 * @property amazonImage
 * @property plasticOceanImage
 */
const useOurCausesImagesData = () => useStaticQuery(ourCausesQuery)

export default useOurCausesImagesData
